export const f1ChartColors = [
  '#7cb5ec',
  '#434348',
  '#90ed7d',
  '#f7a35c',
  '#8085e9',
  '#f15c80',
  '#e4d354',
  '#2b908f',
  '#f45b5b',
  '#91e8e1',
]

export const analyticsColors = [
  '#ee8351',
  '#173e59',
  '#5ba1bf',
  '#b34865',
  '#f4c163',
  '#56b9aa',
  '#235695',

  /** Former DS */

  '#00579a',
  '#0dbcaa',
  '#fdbf4e',

  '#c23e65',
  '#3ea3c2',

  '#003f5c',
  '#ff7c43',

  '#00579a',
  '#ff0f08',
  '#098d6c',
  '#da70d6',
  '#ffd700',

  '#07db98',
  '#7fffd4',
  '#0471d9',
  '#07e6de',
  '#05e81f',

  '#556b2f',
  '#c8de04',
  '#e69305',
  '#182581',
  '#ffdcac',

  '#7406cc',
  '#fe8405',
  '#ff69b4',
  '#873e6c',
  '#19d7ff',

  '#7b68ee',
  '#71d73d',
  '#b53616',
  '#0db57e',
  '#2898b5',

  '#b56216',
  '#af28b5',
  '#a6be59',
  '#140ab7',
  '#e8e21c',

  '#64a03c',
  '#bd9fa5',
  '#7e6667',
  '#6b8e23',
  '#005c5c',

  '#8c96bd',
  '#f9b4f8',
  '#66cdaa',
  '#2c75ff',
  '#4b0082',

  '#d8bfd8',
  '#ff00ff',
  '#00ff00',
  '#fbaa99',
  '#66ccff',

  '#ff0067',
  '#a4bea0',
  '#73ce11',
  '#96dccf',
  '#440bd4',

  '#da8886',
]
